/* tslint:disable */
/* eslint-disable */
/**
 * SmartAI BMAW
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ChatFileGroundingInfoModel } from './ChatFileGroundingInfoModel';
import {
    ChatFileGroundingInfoModelFromJSON,
    ChatFileGroundingInfoModelFromJSONTyped,
    ChatFileGroundingInfoModelToJSON,
    ChatFileGroundingInfoModelToJSONTyped,
} from './ChatFileGroundingInfoModel';
import type { ChatExchangeModel } from './ChatExchangeModel';
import {
    ChatExchangeModelFromJSON,
    ChatExchangeModelFromJSONTyped,
    ChatExchangeModelToJSON,
    ChatExchangeModelToJSONTyped,
} from './ChatExchangeModel';

/**
 * 
 * @export
 * @interface ChatThreadModel
 */
export interface ChatThreadModel {
    /**
     * 
     * @type {string}
     * @memberof ChatThreadModel
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ChatThreadModel
     */
    threadSummary: string;
    /**
     * 
     * @type {boolean}
     * @memberof ChatThreadModel
     */
    visibleToUser: boolean;
    /**
     * 
     * @type {Date}
     * @memberof ChatThreadModel
     */
    lastActivity: Date;
    /**
     * 
     * @type {string}
     * @memberof ChatThreadModel
     */
    userId: string;
    /**
     * 
     * @type {Array<ChatExchangeModel>}
     * @memberof ChatThreadModel
     */
    readonly exchanges?: Array<ChatExchangeModel> | null;
    /**
     * 
     * @type {Array<ChatFileGroundingInfoModel>}
     * @memberof ChatThreadModel
     */
    readonly groundingFileInfos: Array<ChatFileGroundingInfoModel>;
}

/**
 * Check if a given object implements the ChatThreadModel interface.
 */
export function instanceOfChatThreadModel(value: object): value is ChatThreadModel {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('threadSummary' in value) || value['threadSummary'] === undefined) return false;
    if (!('visibleToUser' in value) || value['visibleToUser'] === undefined) return false;
    if (!('lastActivity' in value) || value['lastActivity'] === undefined) return false;
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('groundingFileInfos' in value) || value['groundingFileInfos'] === undefined) return false;
    return true;
}

export function ChatThreadModelFromJSON(json: any): ChatThreadModel {
    return ChatThreadModelFromJSONTyped(json, false);
}

export function ChatThreadModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChatThreadModel {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'threadSummary': json['threadSummary'],
        'visibleToUser': json['visibleToUser'],
        'lastActivity': (new Date(json['lastActivity'])),
        'userId': json['userId'],
        'exchanges': json['exchanges'] == null ? undefined : ((json['exchanges'] as Array<any>).map(ChatExchangeModelFromJSON)),
        'groundingFileInfos': ((json['groundingFileInfos'] as Array<any>).map(ChatFileGroundingInfoModelFromJSON)),
    };
}

export function ChatThreadModelToJSON(json: any): ChatThreadModel {
    return ChatThreadModelToJSONTyped(json, false);
}

export function ChatThreadModelToJSONTyped(value?: Omit<ChatThreadModel, 'exchanges'|'groundingFileInfos'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'threadSummary': value['threadSummary'],
        'visibleToUser': value['visibleToUser'],
        'lastActivity': ((value['lastActivity']).toISOString()),
        'userId': value['userId'],
    };
}

